// 按页面划分
export default {
    // 公共页面
    common: {
        title: "Centro de dados",
        pull_refresh: "Puxe para baixo para atualizar",
        release_refresh: "Solte para atualizar",
        refresh_loading: "Carregando…",
        footer_text: "Serviços fornecidos por Ucloudlink (NASDAQ: UCL)"
    },
    home: {
        input_placeholder: "Pesquisar país/região",
        my_flow: "Meus dados",
        charge_code: "Código do voucher",
        coupons:'Cupons',
        local_package: "Dados locais",
        more: "Mais",
        popular_destination: "País/região",
        buy_now: "Comprar agora",
        package_useing: "Ativo",
        unused: 'Inativo',
        download_app: "Baixar aplicativo",
        enter_the_mall_list: "Ir para a lista de compras",
        no_data: "Sem dados",
        no_data_available: 'Nenhum dado disponível',
        copy_success: "Copiar com sucesso",
        copy_fail: "Falha ao copiar",
        meritsTitle: 'Quais são as vantagens?',
        merits1: 'Sem SIM necessário & Sem taxa mensal',
        merits2: 'Integrado com os 2-3 operadores de topo para mudança automática de rede',
        go_buy: 'Ir comprar',
        instant_savings: 'Poupe',
        expires_in: 'Expira em',
        download_app_tips: "Baixe a app para mais ofertas e experiências"
    },
    packages: {
        sub_title: {
            us: "Excluindo Guam, Saipan",
            it: "Incluindo Cidade do Vaticano, San Marino",
            va: "Incluindo Itália, São Marino",
            sm: "Incluindo Itália, Cidade do Vaticano",
            ma: "Incluindo o Saara Ocidental",
            eh: "Incluindo Marrocos",
            ch: "Incluindo Liechtenstein",
            li: "Incluindo a Suíça",
            fr: "Incluindo Mônaco",
            mc: "Incluindo França",
            fi: "Including Aland Islands",
            ax: "Incluindo Finlândia",
            gu: "Incluindo Ilhas Marianas do Norte",
            mp: "Incluindo Guam"
        },
        unlimited_packages: "Pacote de dados ilimitado",
        normal_packages: "Pacote de dados normal",
        multi_region_packages: "Multirregião",
        regional_data: "Dados Regionais",
        high_speed_text: "dados de alta velocidade",
        infiniteFlow: "Dados ilimitados",
        unLimitData: 'Ilimitado',
        high_speed_text_year: "alta velocidade/mp",
        package_list: "Lista de pacotes",
        special_offer: 'Promoções',
        first_month: '1º Mês',
        periodUnit: {
            day: "dia(s)",
            month: "mês",
            hour: "horas)",
            year: "ano"
        },
        periodUnits: {
            day: "dia(s)",
            month: "meses",
            hour: "horas)",
            year: "anos"
        },
        periodUnitSimp: {
            day: "d",
            month: "para",
            hour: "h",
            year: "o"
        },
        periodUnitMonthly:'Mensal',
        periodUnitsSimp: {
            day: "d",
            month: "para",
            hour: "h",
            year: "o"
        },
        unlimited_good_name: {
            day: "Passe Diário",
            month: "Passe Mensal",
            year: "Passe Anual"
        },
        continuousMonth: "Meses contínuos",
        continuousDay: "Dias contínuos",
        continuousYear: "Anos contínuos",

        day_invalid: "Expira no dia atual",
        month_invalid: "Expira no mês atual",
        immediate_valid: "Em vigor imediatamente",
        tomorrow_day_valid: "Em vigor a partir do dia seguinte",
        tomorrow_month_valid: "Em vigor a partir do próximo mês",

        // detail page
        detail: {
            cell_flow: "Dados",
            cell_period: "Validade",
            buy_quantity: "Quantia",
            use_area: "Cobertura",
            use_intro: "Termos e Condições",
            buy_btn: "Ordem",
            pay: "Pagar",
            buy_tips: 'Tem o pacote %@packageName em uso. Quer comprar este pacote?',
            haveOrderTips: "Encomenda pendente de pagamento gerada. Clique Confirmar para ir à minha página de dados！"
        },

        // confirm page
        confirm: {
            title: "Confirmação do pedido",
            real_pay_amount: "Valor pago",
            online_payment: "Pagamento on-line",
            create_order_error: "Falha na configuração"
        }
    },
    pay: {
        // result page
        result: {
            loading_order_status: "Obtendo status do pedido…",
            buy_success: "Pedido concluído",
            buy_pending: "Confirmação pendente",
            buy_pending_tip: "Pagamento em andamento... Se o pagamento não for transferido dentro de 10 minutos, entre em contato conosco para obter suporte.",
            get_payment_info_fail: "Falha na aquisição de informações de pagamento",
            cell_package: "Pacote",
            cell_buy_amount: "Subtotal",
            cell_real_amount: "Valor pago",
            go_to_order_btn: "Vá para Meu Pacote",
            back_home: "De volta para casa",
            back_mall: "De volta ao shopping",
            ordersn_empty: "O SN do pedido não pode estar vazio",
            order_search_error: "Erro inesperado",
            goodsName:'Nome do produto'
        },

        //fail page
        fail: {
            payment_fail: "Falha no pagamento",
            back_home: "De volta para casa"
        }
    },
    CountryGroup: {
        title: "País/região",
        placeholder: "Pesquisar país ou região",
        clear: "Claro",
        history: "Histórico de pesquisa"
    },
    PromotionCode: {
        verification: {
          title: "Código do voucher",
          minititle: "Código do voucher",
          input: "Por favor insira o código de recarga",
          explain: "Dicas: Toque no botão de digitalização no canto superior direito para digitalizar o código QR do cartão voucher ou insira manualmente o código do voucher (diferencia maiúsculas de minúsculas) se não funcionar.",
          submit: "Enviar",
          exchange: "Resgatar",
          cancel: "Cancelar",
          Inquiry: "Tem certeza de trocar",
          ErrorCode: "Erro no código de recarga"
        },
        recharge_success: {
          package: "Pacote",
          content: "Resgatado com sucesso",
          back: "De volta ao Shopping",
          view_packets: "Vá para Meu Pacote"
        }
      },
      order: {
        state: {
          inUse: "Ativado",
          isFirst: "Priorizado",
          toFirst: "Definir prioridade",
          inactive: "Inativado"
        },
        periodUnits: {
          minute: "minuto(s)",
          hour: "horas)",
          day: "dia(s)",
          month: "meses)"
        },
        useIntro: {
          tip1: "O pacote de dados ilimitado tem prioridade mais alta que o pacote de dados de volume;",
          tip2: "A prioridade de uso será baseada na data de compra para o mesmo tipo de pacote, ou seja, o pacote com a data de compra mais antiga será utilizado primeiro, enquanto a prioridade dos pacotes de região única é maior que a do pacote regional;",
          tip3: "Você também pode ajustar manualmente a prioridade de uso de pacotes do mesmo tipo."
        },
        myFlow: "Meus dados",
        remainingFlow: "Dados restantes",
        remainingTime: "Esquerda válida",
        remainingHighFlow: "Dados de alta velocidade restantes",
        validPeriod: "Validade",
        noneFlow: "Nenhum pacote de dados",
        noneFlowTip: "Adquira o pacote de dados e aproveite a rede de alta qualidade",
        buyPackFlow: "Comprar pacotes",
        checkInvalidFlow: "Verifique o pacote de dados expirado",
        orderList: {
          "title": "minhas ordens",
          "amount_paid": "Total",
          "device": "Dispositivo de propriedade",
          "order_details": "Detalhes do pedido",
          "total_amont": "Subtotal",
          "orderSN": "Pedido nº.",
          "createTime": "Hora de criação",
          "cancelTime": "Horário fechado",
          "payTime": "Hora do pedido",
          "unsubTime": "Hora cancelada",
          "payMethod": "Método de pagamento",
          "thirdSN": "Transação não.",
          "delete": "Excluir",
          "cancel": "Cancelar pedido",
          "unsub": "Reembolso",
          "goto_cancel": "Deseja cancelar o pedido?",
          "goto_unsubscribe": "Deseja cancelar a assinatura do pedido?",
          "delete_Tips": "O pedido não pode ser retomado após ser excluído, portanto, seus problemas pós-serviço não poderão ser resolvidos.Tem certeza de excluí-lo?",
          "status_success": "Concluído",
          "status_pending": "Não pago",
          "status_cancel": "Fechado",
          "status_unsub": "Cancelado",
          "payMethod_stripe": "Cartão de crédito"
        },
      },
      registerlogin: {
        create_account_tip:"Crie uma conta, inicie a experiência exclusiva",
        select_country_tip:"Uso de dispositivo Country/Region",
        email_name: "Correspondência",
        phone_name: "Telefone",
        email_address: "Endereço de email",
        password: "senha",
        country: "país",
        select_country: "Escolha um país",
        cancel: "Cancelar",
        confirm: "Claro",
        please_enter: "Por favor, digite 6-20 caracteres (combinação de letras, números ou símbolos)",
        select_country_tips: "A seleção de países é para visualizar pacotes locais. Não pode ser alterado após o registro. Por favor, confirme!",
        global_roaming: "Código de domínio internacional",
        phone_number: "número de telefone",
        agree: "concordar",
        user_agreement: "Contrato de usuário",
        and: "e",
        privacy_policy: "política de Privacidade",
        register_login: "Inscreva -se ou faça login",
        login_error: "O número de logins é muito frequente, tente novamente mais tarde!",
        register_error: "O número de registros é muito frequente, tente novamente mais tarde!",
        forgot_pwd: "Esqueça a senha",
        app_tips: "Faça login no aplicativo com esta conta depois de baixá -la para acessar mais recursos.",
        download_app: "Vá para baixar o aplicativo",
        rememberPwd: "Lembre -se de senha",
        third_login: 'Continuar com',
        agreement_tips: "Por favor, marque a caixa Contrato do Usuário e Política de Privacidade",
        selectCountry_tips: "Por favor, observe que o país registrado afetará diretamente os seguintes métodos de pagamento e moedas, selecione de acordo com sua necessidade.",
        login_error_cancel: "O utilizador cancelou a autenticação",
        login_error_auth: "Permita pop-ups nas definições do navegador",
        device_tips: "Dispositivo a aguardar ativação. Processado em 24h."
      },
      forgotPwd: {
        forgot_pwd: "Esqueça a senha",
        email_address: "Endereço de email",
        next: "Próximo",
        email_has_been_sent: "Enviamos um email para %@email. Clique no link e siga as etapas para recuperar sua senha.",
        have_retrieved_it: "Eu encontrei",
        unable_to_receive_email: "Não pode receber o email? Verifique se há e -mails de %@email sob seu spam e diretório de correio excluído",
        or: "ou",
        resend: "Reenviar",
        global_roaming: "Código de domínio internacional",
        phone_number: "número de telefone",
        verification_code_has_been_sent: "Enviamos o código de verificação para:",
        verification_code: "Código de verificação",
        no_verification_code_received: "Não recebeu o código de verificação?",
        please_enter: "Por favor, digite 6-20 caracteres (combinação de letras, números ou símbolos)",
        reset_password: "Redefinir senha",
        reset_successful: "Redefinir com sucesso"
      },
      coupons: {
        coupons_name: "Cupons",
        no_coupons: "Sem cupons ainda",
        no_data: "Ainda não há dados",
        applicable_to_the_following: "Cupons são adequados para o seguinte pacote de dados"
      },
      digital: {
        title: "Dispositivo SN",
        purchased: "Minhas compras",
        viewAll: "Mais",
        skinStore: "Loja de produtos",
        completed: "Comprado",
        goBuy: "Comprar",
        order: {
            title: "Pedidos comprados"
        },
        detail: {
            describe: "Descrição"
        }
      },
      viewPL: {
        other: 'outros'
      },
      invalidFlow: {
        stateName: "Status",
        state: {
          NOT_ACTIVATED: "Inativado",
          IN_USING: "Disponível",
          USE_END: "Esgotado",
          EXPIRE: "Expirado",
          TRANSFER: "Transferir",
          UNSUBSCRIBE: "Cancelar",
          VALID: "Válido",
          INVALID: "Inválido",
          EXCHANGE_POINTS: "Resgatar pontos"
        },
        noneFlow: "Nenhum pacote de dados expirado",
        pageName: "Pacote de dados expirado"
      },
      flowDetail: {
        title: "Detalhes dos dados",
        flow: "Dados",
        validTime: "Detalhes dos dados",
        invalidTime: "Válido até",
        coverage: "Cobertura",
        useIntro: "Termos e Condições",
        purchaseTime: "Comprado em",
        subtotal: "Subtotal",
        status: "Status",
        cancel: "Cancelar",
        buyAgain: "Compre de novo",
        validity: "Validade",
        tip: "Perceber",
        cancelTip: "Tem certeza de que deseja reembolsar este pacote?",
        dataLeft: "Dados restantes"
      },
      netError: {
        try_again: "Tente novamente",
        net_error: "Sem rede",
        try_again_desc: "Verifique a configuração de rede e tente novamente"
      },
      loadFail: {
        try_again: "Tente novamente",
        load_fail: "Falha no carregamento",
        load_fail_desc: "Falha ao carregar dados, tente novamente",
        IMEI_Not_Exist: "IMEI não existe, tente entrar pela entrada direita",
        Project_Not_Exist: "Ocorre um erro. Entre em contato com o atendimento ao cliente.(01)",
        commonError: "Ocorre um erro. Entre em contato com o atendimento ao cliente."
      },
      settlement_Easy_and_convenient: "Fácil e conveniente",
      settlement_Great_deal: "Grande coisa",
      settlement_Safe_and_secure: "Seguro e seguro",
      settlement_Autopay_service_regulation: "Regulamento do Serviço Autopay",
      settlement_Read: "Ler",
      settlement_No_coupon: "Sem cupom disponível",
      settlement_Subtotal: "Subtotal",
      settlement_Coupon: "Cupom",
      settlement_TOTAL: "Total",
      settlement_promotion_tip: "A oferta promocional não pode ser usada em conjunto com nenhum cupons",
      settlement_coupon_tip: "O cupom não pode ser usado em conjunto com outras ofertas promocionais",
      member_myFlow_noList: "No Data",
      detail_se_content: "Uma maneira segura, fácil e conveniente. Você pode cancelar a inscrição a qualquer momento",
      Enter_Promo_code: "Código de promoção",
      Enter_Promo_Coupon:"Cupons",
      settlement_Not_used_coupon:"cupom não usado",
      settlement_Available_coupon:"Disponível",
      settlement_Unavailable_coupon:"Indisponível",
      please_Enter_Promo_code: "Por favor, insira o código de promoção",
      please_Select_Coupon_use:　"Selecione o cupom que você deseja usar.",
      Buy_Now: "Comprar agora",
      Dont_Use_Any: "Não use nenhum",
      settlement_confirm: "Confirmar",
      flowDetail_unsubscribe: "Cair na inscrição",
      flowDetail_unsubscribed: "Cancelado",
      flowDetail_isCancelPackage: "Cancelar a inscrição deste pacote?",
      flowDetail_confirmAgreementUnsubscribe: "Você não pode ter muita coisa após cancelar a inscrição. Tem certeza de que deseja cancelar a inscrição?",
      flowDetail_cancel: "Cancelar",
      flowDetail_cancelSuccess: "Cancelar a inscrição com sucesso",
      packages_detail_promotion: "Promoção",
      orderTips:{
        "iDay" : "dia",
        "iDays" : "dias",
        "iMonth" : "mês",
        "iMonths" : "meses",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol Em sua primeira compra, Pague %@money/%@periodSymbol mais tarde, Você pode cancelar a inscrição a qualquer momento",
        'Monthly_discount':"Salvar %@saveMoney cada %@period! Você pode cancelar a inscrição a qualquer momento ",
        'Ordinary_monthly_package':"Uma maneira segura, fácil e conveniente. Você pode cancelar a inscrição a qualquer momento",
        "AlreadyPurchased":'Desculpe, você só pode se inscrever em um pacote de dados no momento. Por favor, caça a inscrição de “%@” e assine posteriormente qualquer pacote que desejar depois de expirar. ',
        "Contract_recommendation_First":'<label>Com o serviço automático, em sua primeira compra, pague apenas</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Você pode cancelar a inscrição a qualquer momento'
        +'<a class="btn">Inscreva -se ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>Com o serviço automático, pague apenas</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Você pode cancelar a inscrição a qualquer momento'
        +'<a class="btn">Inscreva -se ></a></p>',
        "Contract_recommendation_General":"<label>Com serviço automático</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Uma maneira segura, fácil e conveniente. Você pode cancelar a inscrição a qualquer momento'
        +'<a href="javascript:;" class="btn">Inscreva -se ></a></p>',
        'BanlanceDoubleCheck':'Tem certeza de que deseja pagar com saldo?',
    },
    feedback: {
      title: "feedback",
      placeholder: "Entre no país que você deseja visitar ou qualquer outra pergunta e atenderemos às suas necessidades o mais rápido possível!",
      submit: "Enviar",
      submit_success: "Enviado com sucesso",
      other_opinions: "Outras opiniões",
    },
    view_country_input: 'Por favor insira sua conta',
    select_package: {
      title: 'Selecionar Dados',
      allPackage: 'Todos os Dados',
      type: 'Tipo',
      flow: 'Dados',
      month_package: 'Plano Mensual',
      flow_package: 'Pacote Dados',
      time: 'Duração',
      period: 'Ciclo',
      auto_debit: 'Info Débito Automático',
      auto_subscribe: 'Auto-Renovação',
      detail: 'Detalhes de Dados',
      carrier: 'Operadoras Suportadas',
      country: 'Países Cobertos',
      notice: 'Guia de Compra'
    },
}